function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */
import { Route, BrowserRouter as Router } from 'react-router-dom';
import EmailConfigurationForm from '@engine/components/containers/email-configurations/form';
import EmailConfigurationsTable from '@engine/components/presentational/email-configurations/table';
import React from 'react';
import { connect } from 'react-redux';
import { updateConfigurations } from '@engine/actions/creators/email/entity';

var EmailConfigurationsContainer = /*#__PURE__*/function (_React$Component) {
  _inherits(EmailConfigurationsContainer, _React$Component);

  var _super = _createSuper(EmailConfigurationsContainer);

  function EmailConfigurationsContainer(props) {
    var _this;

    _classCallCheck(this, EmailConfigurationsContainer);

    _this = _super.call(this, props);

    _this.props.updateConfigurations(_this.props.emailConfigurations);

    return _this;
  }
  /**
   * Render component
   */


  _createClass(EmailConfigurationsContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(Router, null, React.createElement(Route, {
        exact: true,
        path: "*/:owner_type/:id/email_configurations",
        render: function render(routerParams) {
          return React.createElement(EmailConfigurationsTable, {
            baseUrl: routerParams.match.url
          });
        }
      }), React.createElement(Route, {
        exact: true,
        path: "*/:owner_type/:owner_id/email_configurations/:id/edit",
        render: function render(routerParams) {
          return React.createElement(EmailConfigurationForm, {
            baseUrl: routerParams.match.url.replace('/edit', ''),
            emailConfigurationId: routerParams.match.params.id,
            emailConfigurationTypes: _this2.props.emailConfigurationTypes
          });
        }
      }), React.createElement(Route, {
        exact: true,
        path: "*/:owner_type/:owner_id/email_configurations/new",
        render: function render(routerParams) {
          return React.createElement(EmailConfigurationForm, {
            isNew: true,
            baseUrl: routerParams.match.url.replace('/new', ''),
            emailConfigurationId: null,
            emailConfigurationTypes: _this2.props.emailConfigurationTypes
          });
        }
      }));
    }
  }]);

  return EmailConfigurationsContainer;
}(React.Component);

export default connect(null, {
  updateConfigurations: updateConfigurations
})(EmailConfigurationsContainer);